export enum PhoneNumberFormat {
    INTERNATIONAL,
    NL_MOBILE,
    NL_PHONE
}
